import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useToast } from "@packsize/toast";

import { reproducePackagingSolutionByBatchId } from "@/api/audit-api";

export const useReproduceSingle = () => {
	const intl = useIntl();
	const navigate = useNavigate();
	const { toastSuccess, toastError } = useToast();

	const { mutate: reproduceSingleFromBatch, isPending: isReproduceSingleFromBatchPending } = useMutation({
		mutationFn: ({ batchId }: { batchId: string }) => {
			return reproducePackagingSolutionByBatchId(batchId);
		},
		onSuccess: (response) => {
			const title = intl.formatMessage(
				{
					id: "{alias} sent to queue",
					defaultMessage: "{alias} sent to queue",
				},
				{ alias: response.data.alias },
			);

			toastSuccess({
				title,
				message: intl.formatMessage({ id: "Click here to view", defaultMessage: "Click here to view" }),
				onClick: () => navigate("/production/orders"),
			});
		},
		onError: (error: { status: number }) => {
			console.error("Reproduce error", error);
			if (error.status === 404) {
				toastError({
					message: intl.formatMessage({
						id: "Unable to reproduce deleted or pending orders",
						defaultMessage: "Unable to reproduce deleted or pending orders",
					}),
				});
			} else {
				toastError({
					message: intl.formatMessage({
						id: "Failed to reproduce a job from the batch",
						defaultMessage: "Failed to reproduce a job from the batch",
					}),
				});
			}
		},
	});

	return { reproduceSingleFromBatch, isReproduceSingleFromBatchPending };
};
